import { defer, LoaderFunction, useLoaderData } from "react-router-dom";
import { DecimalResult } from "../../../common/api/decimal/utils.ts";
import { getFavorites } from "../../../common/api/decimal/methods/favorites.ts";
import { getAssetsByVbid } from "../../../common/api/bridge/methods.ts";
import { ExploreAugmentedAsset } from "../../../common/api/decimal/common-types/manageAssets.ts";

const getFavoritesData = () => {
  return new Promise<DecimalResult<ExploreAugmentedAsset[]>>(
    (resolve, reject) => {
      getFavorites()
        .then((favoritesResult) => {
          if (!favoritesResult.ok) {
            reject(new Error("Could not load favorites"));
          }
          const vbids = favoritesResult.ok
            ? favoritesResult.data?.map((fave) => fave.manageAsset.vbid)
            : [];
          if (vbids?.length) {
            return getAssetsByVbid(vbids).then((bridgeResult) => {
              const exploreLookup = bridgeResult.content.reduce<
                Record<string, VST.Bridge.Asset>
              >((acc, curr) => {
                acc[curr.vbid] = curr;
                return acc;
              }, {});
              const res = favoritesResult as DecimalResult<
                ExploreAugmentedAsset[]
              >;
              if (res.data) {
                for (const asset of res.data) {
                  asset.explore = exploreLookup[asset.manageAsset.vbid];
                }
              }
              resolve(res);
            });
          } else {
            resolve(favoritesResult as DecimalResult<ExploreAugmentedAsset[]>);
          }
        })
        .catch((error) => reject(error));
    }
  );
};

export const favoritesLoader: LoaderFunction = () => {
  const favorites = getFavoritesData();
  return defer({ favorites });
};

export function useFavoritesLoader() {
  return useLoaderData() as {
    favorites: ReturnType<typeof getFavoritesData>;
  };
}
